type LogoProps = {
  className?: string;
};

export default function Logo({ className }: LogoProps) {
  return (
    <svg
      width="148"
      height="23"
      viewBox="0 0 148 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.6186 20.0337C89.1467 20.0337 92.5126 15.685 92.5126 11.0168C92.5126 6.34872 89.1467 2 83.6186 2C78.0906 2 74.7246 6.34872 74.7246 11.0168C74.7246 15.685 78.0906 20.0337 83.6186 20.0337ZM83.6186 17.5031C79.9579 17.5031 77.6975 14.3582 77.6975 11.0168C77.6975 7.67545 79.9579 4.53061 83.6186 4.53061C87.2794 4.53061 89.5398 7.67545 89.5398 11.0168C89.5398 14.3582 87.2794 17.5031 83.6186 17.5031Z"
        fill="#34BBEB"
      />
      <path
        d="M147.14 4.94828V2.41767H135.679V13.1011H144.25V10.5807H138.504V4.94828H147.14Z"
        fill="#34BBEB"
      />
      <path
        d="M135.679 17.0917V19.616H147.14V17.0917H135.679Z"
        fill="#34BBEB"
      />
      <path
        d="M27.626 19.616H37.2939V17.0854H30.4514V2.41767H27.626V19.616Z"
        fill="#34BBEB"
      />
      <path
        d="M63.8014 2.41767L55.276 19.616H52.1803L55.5954 12.7367L49.1583 2.41767H52.426L57.0204 9.81295L60.7057 2.41767H63.8014Z"
        fill="#34BBEB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.417 8.43709C119.417 11.6802 117.034 14.4565 113.349 14.4565H110.007V19.616H107.182V2.41767H113.349C117.034 2.41767 119.417 5.19398 119.417 8.43709ZM116.592 8.43709C116.592 6.54527 115.314 4.94828 113.349 4.94828H110.007V11.9259H113.349C115.314 11.9259 116.592 10.3289 116.592 8.43709Z"
        fill="#34BBEB"
      />
      <path
        d="M11.8213 4.94816V2.41767H0.359863V4.94816H11.8213Z"
        fill="#34BBEB"
      />
      <path
        d="M8.82101 10.5846H0.359863V19.616H11.8213V17.0854H3.1853V13.1113H8.82101V10.5846Z"
        fill="#34BBEB"
      />
    </svg>
  );
}
